
import { PropType } from 'vue'
import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'
import TimeDuration from '@/views/Project/ch/components/workAlert/timeDuration.vue'

export default {
    name: 'LogItem',
    components: { LogTemplate, TimeDuration },
    props: {
        log: {
            type: Object as PropType<Log>,
            required: true,
        },
    },
    computed: {
        newPath() {
            let paths = [...this.log.payload.newNamePath]
            paths.pop()
            return paths.join(' → ')
        },
        pathName() {
            if (this.log.payload.namePath) {
                if (!Array.isArray(this.log.payload.namePath)) {
                    return ''
                }

                let paths = [...this.log.payload.namePath]
                let lastPath = paths.pop()
                return lastPath + (paths.length > 0 ? ` (${paths.join(' → ')})` : '')
            } else {
                return this.log.payload.company?.name
            }
        },
        customString() {
            switch (this.log.logEventName) {
                case 'formResponseSubmittedAdmin':
                case 'formResponseSubmitted':
                    return `${this.log.logEventName}_${
                        this.log.payload['pendingApproval']
                            ? 'isTrue(pendingApproval)'
                            : 'isFalse(pendingApproval)'
                    }`

                case 'responseReminder':
                    return `${this.log.logEventName}_${
                        this.log.payload['deadline'] ? 'notNull(deadline)' : 'isNull(deadline)'
                    }`

                case 'companyDocumentIsVisibleToCompanyAdminsUpdated':
                case 'contractorHierarchyNodeIsApprovedUpdated':
                    return `${this.log.logEventName}_${
                        this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                    }`

                case 'contractorHierarchyNodeCreatedBySystem':
                    return `${this.log.logEventName}.isEqual(source,${this.log.payload.source})`

                case 'workAlertDefinitionValidFromUpdated':
                case 'workAlertDefinitionValidToUpdated':
                case 'companyDetailsEndDateUpdated':
                case 'companyDetailsStartDateUpdated':
                    return `${this.log.logEventName}_${
                        this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                    }`

                case 'invalidCardCheckIn':
                    return this.log.accepted
                        ? `${this.log.logEventName}.isTrue(accepted)`
                        : `${this.log.logEventName}.isFalse(accepted)`

                case 'contractorHierarchyNodeRolesUpdated': {
                    if (
                        Array.isArray(this.log.payload.added) &&
                        this.log.payload.added.length > 0
                    ) {
                        return `${this.log.logEventName}_added`
                    } else if (
                        Array.isArray(this.log.payload.removed) &&
                        this.log.payload.removed.length > 0
                    ) {
                        return `${this.log.logEventName}_removed`
                    }
                }

                default:
                    return this.log.logEventName
            }
        },
    },
}
